import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel, SectionDivider } from '@/components/Panel';
import { Mail, Phone } from 'lucide-react';

export default function ContactPage() {
 const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
 const [state, setState] = useState({ loading: false, ok: false, error: '' });
 const [content, setContent] = useState({});

 useEffect(() => { (async () => { try { const { data } = await api.get('/site-content'); setContent(data.content || {}); } catch (err) { console.warn('[ContactPage] site-content fetch failed', err); } })(); }, []);

 const submit = async (e) => {
 e.preventDefault();
 setState({ loading: true, ok: false, error: '' });
 try {
 await api.post('/contact', form);
 setState({ loading: false, ok: true, error: '' });
 setForm({ name: '', email: '', subject: '', message: '' });
 } catch {
 setState({ loading: false, ok: false, error: 'Could not send. Try again.' });
 }
 };

 return (
 <div className="max-w-6xl mx-auto px-6 py-14">
 <div className="text-center">
 <div className="h-eyebrow">Correspondence</div>
 <h1 className="h-display text-5xl md:text-6xl mt-2" style={{ color: 'var(--heritage-plum)' }}>Write to us</h1>
 <p className="opacity-85 max-w-lg mx-auto mt-3" style={{ color: 'var(--heritage-plum)' }}>
 For press, wholesale, ambassador applications, or a note from the field. we read every message ourselves.
 </p>
 </div>

 <SectionDivider />

 <div className="grid md:grid-cols-3 gap-6">
 <div className="md:col-span-1 space-y-4">
 <Panel className="p-6">
 <div className="h-eyebrow mb-2">Email</div>
 <div className="flex items-center gap-2 h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>
 <Mail size={18} /> {content.contact_email || 'hello@heritageapparel.co.nz'}
 </div>
 </Panel>
 <Panel className="p-6">
 <div className="h-eyebrow mb-2">Phone</div>
 <div className="flex items-center gap-2 h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>
 <Phone size={18} /> {content.contact_phone || '+64 21 000 0000'}
 </div>
 </Panel>
 <Panel className="p-6">
 <div className="h-eyebrow mb-2">Atelier</div>
 <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>Aotearoa, New Zealand</div>
 <div className="text-sm mt-1 opacity-80" style={{ color: 'var(--heritage-plum)' }}>Visits by appointment only.</div>
 </Panel>
 </div>

 <Panel className="md:col-span-2 p-8">
 <form onSubmit={submit} className="space-y-4">
 <div className="grid md:grid-cols-2 gap-4">
 <div>
 <label className="h-label">Name</label>
 <input className="h-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
 </div>
 <div>
 <label className="h-label">Email</label>
 <input className="h-input" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
 </div>
 </div>
 <div>
 <label className="h-label">Subject</label>
 <input className="h-input" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" />
 </div>
 <div>
 <label className="h-label">Message</label>
 <textarea className="h-input" rows={6} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
 </div>
 <button type="submit" disabled={state.loading} className="h-btn" data-testid="contact-submit">
 {state.loading ? 'Sending...' : 'Send message'}
 </button>
 {state.ok && <div className="text-sm" style={{ color: '#5B6E2C' }}>Thank you. your message has been received.</div>}
 {state.error && <div className="text-sm text-red-600">{state.error}</div>}
 </form>
 </Panel>
 </div>
 </div>
 );
}
